export default function getStripString(string) {
  return string.replace(/(<([^>]+)>)/ig,'');
}
